import './styles.scss';
import { AssetOverview as ModalAssetOverview } from '../../../components/Modal/components/asset-overview-tab';
import { BucketDataType, TagType } from '../../../types/bucketTypes';
import { useEffect } from 'react';
import { useAnalyticsEvent } from '../../../hooks/useAnalyticsEvent';

interface AssetOverviewProps {
    asset: BucketDataType | undefined;
    assetStatus?: string;
    tagData: TagType | undefined;
}

export default function AssetOverview(props: Readonly<AssetOverviewProps>) {
    const logAnalyticsEvent = useAnalyticsEvent();
    const { asset, tagData, assetStatus, ...fieldProps } = props;
     // assetStatus: prefer asset.asset_status
    useEffect(() => {
        logAnalyticsEvent('web_user_viewed_asset_overview_tab', { description: 'User viewed asset overview tab', assetId: asset?.asset_id });
    }, []);
    if (!asset) return null;
    return (
        <ModalAssetOverview
            assetStatus={asset?.asset_status}
            selectedAsset={asset}
            tagData={tagData as TagType}
            {...fieldProps}
        />
    );
}